import React from "react";
import { Button, cn } from "@lemonadetraining/web-ui";

export interface EmptyStateCTA {
  label: string;
  onClick: () => void;
}

export interface EmptyStateProps {
  title?: string;
  message: string;
  cta?: EmptyStateCTA;
  icon?: React.ReactNode;
  /** Optional override for the section's data-testid. */
  ["data-testid"]?: string;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  message,
  cta,
  icon,
  className,
  "data-testid": dataTestId = "empty-state",
}) => {
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid={dataTestId}
      className={cn("flex flex-col items-center gap-3 px-4 py-6 text-center", className)}
    >
      {icon ? (
        <span
          data-testid={`${dataTestId}-icon`}
          aria-hidden="true"
          className="text-muted-foreground"
        >
          {icon}
        </span>
      ) : null}
      {title ? (
        <h3 data-testid={`${dataTestId}-title`} className="text-base font-semibold">
          {title}
        </h3>
      ) : null}
      <p data-testid={`${dataTestId}-message`} className="text-sm text-muted-foreground">
        {message}
      </p>
      {cta ? (
        <Button type="button" onClick={cta.onClick} data-testid={`${dataTestId}-cta`}>
          {cta.label}
        </Button>
      ) : null}
    </div>
  );
};

export default EmptyState;
